import { useEnquiry } from "./EnquiryModal";
import { waLink, DEFAULT_WA_MSG } from "../lib/site";
import { WaIcon } from "./icons";

export const FloatingCTAs = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <>
      <a
        data-testid="floating-whatsapp-button"
        href={waLink(DEFAULT_WA_MSG)}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with Paramount Kitchen on WhatsApp"
        className="fixed bottom-5 right-5 z-[60] grid h-14 w-14 place-items-center rounded-full bg-[#128C4B] text-white shadow-2xl ring-4 ring-gold/30 transition-all duration-300 hover:scale-110"
      >
        <WaIcon className="h-7 w-7" />
      </a>

      <button
        data-testid="sticky-estimate-cta"
        onClick={() => openEnquiry({ source: "sticky_desktop" })}
        className="fixed bottom-6 left-5 z-[60] hidden items-center gap-3 rounded-full border border-gold/40 bg-royal py-3.5 pl-5 pr-7 text-sm font-semibold text-ivory shadow-xl backdrop-blur transition-all duration-300 hover:-translate-y-0.5 md:inline-flex"
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-75" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-gold" />
        </span>
        Get Kitchen Estimate
      </button>

      <div data-testid="mobile-sticky-estimate-bar" className="fixed inset-x-0 bottom-0 z-[55] md:hidden">
        <div className="mx-3 mb-3 flex items-center gap-2 rounded-2xl border border-white/10 bg-royal/95 p-2 shadow-2xl backdrop-blur">
          <button
            data-testid="mobile-get-estimate-button"
            onClick={() => openEnquiry({ source: "sticky_mobile" })}
            className="flex-1 rounded-xl bg-gold px-4 py-3.5 text-xs font-bold uppercase tracking-[0.14em] text-royal"
          >
            Get Kitchen Estimate
          </button>
          <a
            data-testid="mobile-whatsapp-button"
            href={waLink(DEFAULT_WA_MSG)}
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp us"
            className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-white/10 text-ivory"
          >
            <WaIcon className="h-6 w-6" />
          </a>
        </div>
      </div>
    </>
  );
};
